import { render, staticRenderFns } from "./billing-payment-status.vue?vue&type=template&id=2304c7a7&scoped=true&lang=pug"
import script from "./billing-payment-status.vue?vue&type=script&lang=js"
export * from "./billing-payment-status.vue?vue&type=script&lang=js"
import style0 from "./billing-payment-status.vue?vue&type=style&index=0&id=2304c7a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304c7a7",
  null
  
)

export default component.exports